export type CardState = {
    value: number;
};

export const initialCardState = {
    value: 0
};
